export const PreCheckMarkingCountryList = [
    'United States',
    'Singapore',
    'China',
    'Malaysia',
    'Taiwan',
    'Hong Kong',
    'India',
];
